//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';

//local imports
import { CategoryModel } from '@app/catalog';
import { PresenterType } from '@app/shared';



@PresenterType({
  model: CategoryModel,
  key: 'tileTop'
})
@Component({
  selector: 'category-carousel-item',
  templateUrl: './category-carousel-item.component.html',
  styleUrl: './category-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CategoryCarouselItemComponent {
  public data: WritableSignal<CategoryModel> = signal<CategoryModel>(undefined);
}
